import { render, staticRenderFns } from "./header-platform-stamp.vue?vue&type=template&id=aebac340&scoped=true"
import script from "./header-platform-stamp.vue?vue&type=script&lang=js"
export * from "./header-platform-stamp.vue?vue&type=script&lang=js"
import style0 from "./header-platform-stamp.vue?vue&type=style&index=0&id=aebac340&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aebac340",
  null
  
)

export default component.exports